import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ConnectionService {
    /**
     * Login states:
     * - loading: Default status before authentication succeeded or error is thrown
     * - authenticated: User is authenticated and profile is loaded (via user service)
     */
    state = new BehaviorSubject<'loading' | 'authenticated'>('loading');

    /**
     * Current hasura role user is acting as
     */
    role = new BehaviorSubject<HasuraRole | undefined>(undefined);
}

export type HasuraRole = 'admin' | 'manager' | 'editor' | 'chatter';
